module.exports = __webpack_public_path__ + "static/media/tom-ford.2a6daf18.jpg";